import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Observable } from 'rxjs';
import { SessionQuery } from 'src/app/state/session.query';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    LanguageSelectorComponent,
    TranslateModule,
    MatSelectModule,
    ClickOutsideDirective,
  ],
})
export class UserMenuComponent {
  userName$: Observable<string>;
  email$: Observable<string>;
  showLanguageSelector = false;

  constructor(private sessionQuery: SessionQuery, private msalService: MsalService) {
    this.userName$ = this.sessionQuery.selectName$;
    this.email$ = this.sessionQuery.selectEmail$;
  }

  showHideLanguageSelector(event: MouseEvent) {
    event.stopPropagation();
    this.showLanguageSelector = !this.showLanguageSelector;
  }

  closeLanguageSelector() {
    this.showLanguageSelector = false;
  }

  signout() {
    this.msalService.logoutRedirect();
  }
}
